import { Box, CardContent, Grid, Paper, Typography } from '@material-ui/core';
import React from 'react';
import { CheckBoxFastField, TextFieldFastField } from '../../../components';

interface SampleDevelopmentHlFinishingProps {
  isCrtLocked?: boolean;
}

const SampleDevelopmentHlFinishing: React.FC<SampleDevelopmentHlFinishingProps> = (
  props,
) => {
  const { isCrtLocked = false } = props;

  return (
    <Box m={1}>
      <Paper variant="outlined">
        <CardContent>
          <Grid
            container
            spacing={1}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            item
            xs={12}
          >
            <Grid item xs={12}>
              <Typography>Finishing</Typography>
            </Grid>
            <Grid
              container
              spacing={1}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              item
              xs={6}
            >
              <Grid item xs={12}>
                <Typography>ด้านหน้า(Front)</Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishLaminate"
                  label="Laminate Film"
                />
              </Grid>
              <Grid item xs={12} md={9} />

              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishLamAdhesive"
                  label="1. Adhesive"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishLamHeatSeal"
                  label="HeatSeal"
                />
              </Grid>
              <Grid item xs={12} md={5} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishLamMatt"
                  label="2. Matt"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishLamGloss"
                  label="Gloss"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishLamHalogram"
                  label="Halogram"
                />
              </Grid>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishLamSoftTouch"
                  label="SoftTouch"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldFastField
                  disabled={isCrtLocked}
                  name="frontFinishLaminateDesc"
                  label="Laminate Film Desc."
                  variant="outlined"
                  margin="dense"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishLamWindow"
                  label="3. Window"
                />
              </Grid>
              <Grid item xs={12} md={8} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishLamFullArea"
                  label="4. Full Area"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishLamSpot"
                  label="Spot"
                />
              </Grid>
              <Grid item xs={12} md={5} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishChemical"
                  label="Chemical"
                />
              </Grid>
              <Grid item xs={12} md={9} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheOilBased"
                  label="1. Oil Based"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheWaterBased"
                  label="Water Based"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheUV"
                  label="UV"
                />
              </Grid>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheUVSilkscreen"
                  label="UV Silkscreen"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheVanish"
                  label="Vanish"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheCalendering"
                  label="Calendering"
                />
              </Grid>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheHighGloss"
                  label="1.1 HighGloss"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheGloss"
                  label="Gloss"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheMatt"
                  label="Matt"
                />
              </Grid>
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheExtraMatt"
                  label="Extra Matt"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheSoftTouch"
                  label="Soft Touch"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheSatin"
                  label="Satin"
                />
              </Grid>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheSpecial"
                  label="Special"
                />
              </Grid>
              <Grid item xs={12} md={7}>
                <TextFieldFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheSpecialData"
                  label="Special"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheFullArea"
                  label="1.2 Full Area"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheSpot"
                  label="Spot"
                />
              </Grid>
              <Grid item xs={12} md={4} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheBlister"
                  label="2. Blister"
                />
              </Grid>
              <Grid item xs={12} md={8} />
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishChePET"
                  label="2.1 PET"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishChePVC"
                  label="PVC"
                />
              </Grid>
              <Grid item xs={12} md={4} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="frontFinishCheWaterResistance"
                  label="3. Water Resistance"
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={1}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              item
              xs={6}
            >
              <Grid item xs={12}>
                <Typography>ด้านหลัง(Back)</Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishLaminate"
                  label="Laminate Film"
                />
              </Grid>
              <Grid item xs={12} md={9} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishLamAdhesive"
                  label="1. Adhesive"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishLamHeatSeal"
                  label="HeatSeal"
                />
              </Grid>
              <Grid item xs={12} md={5} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishLamMatt"
                  label="2. Matt"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishLamGloss"
                  label="Gloss"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishLamHalogram"
                  label="Halogram"
                />
              </Grid>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishLamSoftTouch"
                  label="SoftTouch"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldFastField
                  disabled={isCrtLocked}
                  name="backFinishLaminateDesc"
                  label="Laminate Film Desc."
                  variant="outlined"
                  margin="dense"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishLamWindow"
                  label="3. Window"
                />
              </Grid>
              <Grid item xs={12} md={8} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishLamFullArea"
                  label="4. Full Area"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishLamSpot"
                  label="Spot"
                />
              </Grid>
              <Grid item xs={12} md={5} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishChemical"
                  label="Chemical"
                />
              </Grid>
              <Grid item xs={12} md={9} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheOilBased"
                  label="1. Oil Based"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheWaterBased"
                  label="Water Based"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheUV"
                  label="UV"
                />
              </Grid>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheUVSilkscreen"
                  label="UV Silkscreen"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheVanish"
                  label="Vanish"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheCalendering"
                  label="Calendering"
                />
              </Grid>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheHighGloss"
                  label="1.1 HighGloss"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheGloss"
                  label="Gloss"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheMatt"
                  label="Matt"
                />
              </Grid>
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheExtraMatt"
                  label="Extra Matt"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheSoftTouch"
                  label="Soft Touch"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheSatin"
                  label="Satin"
                />
              </Grid>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheSpecial"
                  label="Special"
                />
              </Grid>
              <Grid item xs={12} md={7}>
                <TextFieldFastField
                  disabled={isCrtLocked}
                  name="backFinishCheSpecialData"
                  label="Special"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheFullArea"
                  label="1.2 Full Area"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheSpot"
                  label="Spot"
                />
              </Grid>
              <Grid item xs={12} md={4} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheBlister"
                  label="2. Blister"
                />
              </Grid>
              <Grid item xs={12} md={8} />
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishChePET"
                  label="2.1 PET"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishChePVC"
                  label="PVC"
                />
              </Grid>
              <Grid item xs={12} md={4} />
              <Grid item xs={12} md={1} />
              <Grid item xs={12} md={3}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="backFinishCheWaterResistance"
                  label="3. Water Resistance"
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={1}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              item
              xs={12}
            >
              <Grid item xs={12} md={2}>
                <Typography>Packing</Typography>
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="prodPackingPiece"
                  label="ชิ้น(Piece)"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="prodPackingSheet"
                  label="แผ่น(Sheet)"
                />
              </Grid>
              <Grid item xs={12} md={6} />
              <Grid item xs={12} md={2}>
                <Typography>งานปั้ม(Die Cut)</Typography>
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="dieCutHold"
                  label="รู(Hold)"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="dieCutShape"
                  label="ตามรูป(Shape)"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="dieCutEmboss"
                  label="นูน(Emboss)"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="dieCutPerforate"
                  label="ปั้มปรุ(Perforate)"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="dieCutFoldLine"
                  label="ปั้มพับ(Fold Line)"
                />
              </Grid>
              <Grid item xs={12} md={2} />
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="dieCutPiece"
                  label="ตัดชิ้น(Piece)"
                />
              </Grid>
              <Grid item xs={12} md={8} />
              <Grid item xs={12} md={2}>
                <Typography>Foil</Typography>
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="foilHotStamping"
                  label="ปั้ม Foil(Hot Stamping)"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CheckBoxFastField
                  disabled={isCrtLocked}
                  name="foilColdStamping"
                  label="ปั้ม Foil(Cold Stamping)"
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextFieldFastField
                  disabled={isCrtLocked}
                  name="foilColorData"
                  label="Foil สี"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                />
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Paper>
    </Box>
  );
};

export default SampleDevelopmentHlFinishing;
